export const topupAutomaticEndpoint = '/cashier-core-ms/v1/topup/automatic';
export const putTopupAutomaticResourceId = 'putTopupAutomaticResourceId';
export const getTopupAutomaticResourceId = 'getTopupAutomaticResourceId';
export const postTopupAutomaticResourceId = 'postTopupAutomaticResourceId';
